import React, { useState, useEffect } from 'react';
import { API_DOMAIN } from './globals'; // Import the global domain name
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

function AAAResult() {

    const [AAAReult, setAAAReult] = useState([]);  // Store the API response
    const [selectedDate, setSelectedDate] = useState(null);
    const [gameTitle, setgameTitle] = useState(null);
    const [loading, setLoading] = useState(true);  // Loading state
    const [error, setError] = useState(null);  // Error state

    const formatDate = (date) => {
        const d = new Date(date);
        return d.toISOString().split('T')[0]; // Extracts 'YYYY-MM-DD'
    };

    const CurrDate = formatDate(new Date());

    const formatDateWithDashes = (date) => {
        const d = new Date(date);
        const day = d.getDate().toString().padStart(2, '0');
        const month = (d.getMonth() + 1).toString().padStart(2, '0'); // Months are 0-based
        const year = d.getFullYear();
        return `${day}-${month}-${year}`;
    };

    const renderCard = (cardKey, altText) => {
        //console.log(cardKey + ", " + altText);
        return cardKey ? (
            <img className="Result" src={`/cards/${cardKey}.png`} alt={altText} width="20" height="30" />
        ) : null;
    };

    const getAAAResult_AllByDate = async () => {
        const userType = sessionStorage.getItem("UserType");
        const userName = sessionStorage.getItem("UserName");

        const selectedDate = document.getElementById("currDate").value; // Get date from input
        
        setLoading(true);
        const url = `${API_DOMAIN}/api/Client/getAAAResult_All.php?ut=${userType}&un=${userName}&dt=${selectedDate}`;
        
        fetch(url, {
            method: 'GET',
            credentials: 'include', // Equivalent to withCredentials:true
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then(response => response.json())
            .then(data => {
                if (data.Status == "Error") {
                    sessionStorage.setItem("LogoutMsg", data.Message)
                    window.location = '/';
                } else {
                    //console.log(data.data);
                    setgameTitle("Amar Akbar Anthony Result (" + formatDateWithDashes(selectedDate) + ")");
                    console.log("gameTitle="+gameTitle);
                    setAAAReult(Array.isArray(data.data) ? data.data : []);
                }
                setLoading(false); // Set loading to false
            })
            .catch(err => {
                setError(err); // Save any error to the state
                setLoading(false); // Set loading to false
            });
    };

    const getAAAResult_AllByRoundID = async () => {
        const userType = sessionStorage.getItem("UserType");
        const userName = sessionStorage.getItem("UserName");

        const RoundID = document.getElementById("RoundID").value; // Get date from input
        
        setLoading(true);
        const url = `${API_DOMAIN}/api/Client/getAAAResult_AllByRoundID.php?ut=${userType}&un=${userName}&rid=${RoundID}`;
        
        fetch(url, {
            method: 'GET',
            credentials: 'include', // Equivalent to withCredentials:true
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then(response => response.json())
            .then(data => {
                if (data.Status == "Error") {
                    sessionStorage.setItem("LogoutMsg", data.Message)
                    window.location = '/';
                } else {
                    //console.log(data.data);
                    setgameTitle("Amar Akbar Anthony "+RoundID+" (" + data.data[0].GameDate + ")");
                    //console.log("gameTitle="+gameTitle);
                    setAAAReult(Array.isArray(data.data) ? data.data : []);
                }
                setLoading(false); // Set loading to false
            })
            .catch(err => {
                setError(err); // Save any error to the state
                setLoading(false); // Set loading to false
            });
    };

    useEffect(() => {
        // Define your parameters
        const param1 = sessionStorage.getItem("UserType");
        const param2 = sessionStorage.getItem("UserName");

        // Create an object to pass parameters to the GET request
        const params = {
            ut: param1,
            un: param2,
            dt: CurrDate,
        };

        setSelectedDate(CurrDate);

        const queryString = new URLSearchParams(params).toString();
        const url = `${API_DOMAIN}/api/Client/getAAAResult_All.php?${queryString}`;

        fetch(url, {
            method: 'GET',
            credentials: 'include', // Equivalent to withCredentials:true
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then(response => response.json())
            .then(data => {
                if (data.Status == "Error") {
                    sessionStorage.setItem("LogoutMsg", data.Message)
                    window.location = '/';
                } else {
                    //console.log(data.data);
                    setgameTitle("Amar Akbar Anthony Result (" + formatDateWithDashes(CurrDate) + ")");

                    setAAAReult(Array.isArray(data.data) ? data.data : []);
                }
                setLoading(false); // Set loading to false
            })
            .catch(err => {
                setError(err); // Save any error to the state
                setLoading(false); // Set loading to false
            });

    }, []);  // Empty dependency array ensures this runs only once when the component mounts

    if (loading) return <p>Loading...</p>;
    if (error) return <p>Error: {error.message}</p>;

    return (
        <>
            <section className="accountste match-content">
                <div className="table_tittle" style={{ background: 'linear-gradient(to right, #622569, #d54be4)',color:'white' }}>
                    <span>{gameTitle}</span>
                </div>
                <div className="col-md-12" style={{paddingTop:'10px'}}>
                    Date : <DatePicker
                        selected={selectedDate}
                        onChange={(date) => setSelectedDate(date)}
                        dateFormat="yyyy-MM-dd"
                        isClearable
                        showYearDropdown
                        scrollableMonthYearDropdown id="currDate" style={{width:'50px'}}
                    />
                    &nbsp; <button className="btn btn-primary" type="button" onClick={getAAAResult_AllByDate} style={{height:'25px',margin:'0px',padding:'0px',width:'60px'}}>&nbsp;Show</button>
                </div>
                <div className="col-md-12" style={{paddingTop:'10px',paddingBottom:'10px'}}>
                    RID : &nbsp;<input type="text" id="RoundID"/>&nbsp;&nbsp; 
                    <button className="btn btn-success" type="button" onClick={getAAAResult_AllByRoundID} style={{height:'25px',margin:'0px',padding:'0px',width:'60px'}}>Search</button>
                </div>
                <div id="divLoading"></div>
                
                <div className="appendAjaxTbl">
                    <div className="table-responsive sports-tabel">
                        <table className="table table-bordered table-hover"  style={{ whiteSpace: 'nowrap',padding:'0px',margin:'0px' }}>
                            <thead>
                                <tr style={{ background: '#000',color:'white'}}>
                                    <th>SN</th>
                                    <th>Round ID</th>
                                    <th>Won</th>
                                    <th>Card</th>
                                    <th>Start Time</th>
                                    <th>Declare Time</th>
                                </tr>
                            </thead>
                            <tbody>
                                {AAAReult.map((row, index) => (
                                    <tr key={index}>
                                        <td style={{ padding:'0px',margin:'0px',verticalAlign:'middle',textAlign:'center', color:'black' }}>{index + 1}</td>
                                        <td style={{ padding:'2px',margin:'2px',verticalAlign:'middle',textAlign:'center', color:'black' }}>
                                            {row.MarketID}
                                        </td>
                                        <td style={{ padding:'0px',margin:'0px',verticalAlign:'middle',textAlign:'center', color:'black' }}>
                                            {row.WonBy}
                                        </td>
                                        <td style={{ padding:'2px',margin:'2px',textAlign:'center',textAlign:'center', color:'black' }}>
                                            <span>
                                                {renderCard(row.C1, "Card 1")}
                                            </span>
                                        </td>
                                        <td style={{ padding:'2px',margin:'2px',verticalAlign:'middle',textAlign:'center', color:'black' }}>
                                            {new Date(row.GameTime).toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: true, timeZone: "Asia/Kolkata" }).toUpperCase()}
                                        </td>
                                        <td style={{ padding:'2px',margin:'2px',verticalAlign:'middle',textAlign:'center', color:'black' }}>
                                            {new Date(row.DeclareDateTime).toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: true, timeZone: "Asia/Kolkata" }).toUpperCase()}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </section>
        </>
    )
}

export default AAAResult;
